import { MESSAGES } from '_constants';
import NEW_REPORTS_TYPES from '_constants/NEW_REPORTS_TYPES';

export const formNames = {
  interestType: 'interest_type',
  interestArea: 'interest_area',
  comparisonType: 'comparison_type',
  comparisonArea: 'comparison_area',
  dateStart: 'date_start',
  dateEnd: 'date_end',
  reportType: 'report_type',
  statewide: 'statewide',
  sellsTobacoo: 'sells_tobacco',
  formIds: 'form_ids',
  agencyIds: 'agency_ids',
};

export const FORM_ACTION_TYPES = {
  ENTER_DATA: 'ENTER_DATA',
  VALIDATE_DATA: 'VALIDATE_DATA',
  SET_ERROR: 'SET_ERROR',
  RESET_DATA: 'RESET_DATA',
  CHANGE_DATE: 'CHANGE_DATE',
  SET_INVALID_DATE_ERROR: 'SET_INVALID_DATE_ERROR',
};

export const FORM_REQUIRED_FIELDS_BASE = [formNames.interestType, formNames.interestArea];

export const FORM_REQUIRED_FIELDS = [...FORM_REQUIRED_FIELDS_BASE, formNames.comparisonType, formNames.comparisonArea];
export const NEW_REPORTS_REQUIRED_FIELDS = {
  [NEW_REPORTS_TYPES.ASSESMENT]: [formNames.dateStart, formNames.dateEnd, formNames.formIds],
  [NEW_REPORTS_TYPES.EDUCATION]: [formNames.dateStart, formNames.dateEnd, formNames.formIds],
  [NEW_REPORTS_TYPES.ENFORCEMENT]: [formNames.dateStart, formNames.dateEnd, formNames.formIds],
  [NEW_REPORTS_TYPES.LANDSCAPE]: [],
};

const setDefaultValue = (name) => {
  switch (name) {
    case formNames.reportType:
      return 'one_geography';
    case formNames.sellsTobacoo:
      return false;

    default:
      return null;
  }
};

const defaultRetailerState = Object.values(formNames).reduce(
  (newObj, name) => ({ ...newObj, [name]: setDefaultValue(name) }),
  {},
);

export const formInitialState = {
  data: defaultRetailerState,
  errors: {},
  canBeSubmitted: false,
};

export const TOBACCO_LANDSCAPE_OPTIONS = [
  {
    text: 'Area summary report for one geography',
    value: 'one_geography',
    label: 'Area summary report for one geography',
    name: 'one_geography',
  },
  {
    text: 'Comparison report for two geographies',
    value: 'two_geographies',
    label: 'Comparison report for two geographies',
    name: 'two_geographies',
  },
];

export const REPORT_GEO_TYPES = {
  oneGeography: 'one_geography',
  twoGeography: 'two_geographies',
};

export const DOWNLOAD_TYPE = {
  Download: {
    type: 'notification',
    message:
      'Your report is currently being generated and may take up to 10 minutes to complete. It will be available for download shortly - please monitor the notification bell for updates.',
  },
  'Send to email': { type: 'email', message: MESSAGES.REPORT.SUCCESS },
};
